"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _item = _interopRequireDefault(require("./tpl/partial/item"));

var _itemTemplated = _interopRequireDefault(require("./tpl/partial/item-templated"));

var _itemCitation = _interopRequireDefault(require("./tpl/partial/item-citation"));

var _items = _interopRequireDefault(require("./tpl/partial/items"));

var _group = _interopRequireDefault(require("./tpl/partial/group"));

var _groups = _interopRequireDefault(require("./tpl/partial/groups"));

var _branding = _interopRequireDefault(require("./tpl/partial/branding"));

var _groupView = _interopRequireDefault(require("./tpl/group-view"));

var _plainView = _interopRequireDefault(require("./tpl/plain-view"));

var _constants = _interopRequireWildcard(require("./constants"));

var _utils = _interopRequireWildcard(require("./utils"));

var _fieldMap = _interopRequireDefault(require("./field-map"));

var _typeMap = _interopRequireDefault(require("./type-map"));

var _hiddenFields = _interopRequireDefault(require("./hidden-fields"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// _.templateSettings.variable = 'obj';

/**
 * Zotero Renderer constructor
 * @param {ZoteroPublications} [zotero]			- ZoteroPublications object
 */
function Renderer(zotero) {
  this.zotero = zotero;
  this.config = zotero.config;
  this.fieldMap = _fieldMap.default;
  this.typeMap = _typeMap.default;
  this.hiddenFields = _hiddenFields.default;
}
/**
 * Render single Zotero item
 * @param  {Object} zoteroItem       - Single Zotero item data
 * @return {String}                  - Rendered markup of a Zotero item
 */


Renderer.prototype.renderItem = function (zoteroItem) {
  return (0, _item.default)({
    'item': zoteroItem,
    'data': zoteroItem.data,
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Render citation part of a single Zotero using custom template
 * @param  {Object} zoteroItem       - Single Zotero item data
 * @return {String}                  - Rendered markup of a Zotero item
 */


Renderer.prototype.renderItemTemplated = function (zoteroItem) {
  return (0, _itemTemplated.default)({
    'item': zoteroItem,
    'data': zoteroItem.data,
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Render citation part of a single Zotero item using api-provided citation
 * @param  {Object} zoteroItem       - Single Zotero item data
 * @return {String}                  - Rendered markup of a Zotero item
 */


Renderer.prototype.renderItemCitation = function (zoteroItem) {
  return (0, _itemCitation.default)({
    'item': zoteroItem,
    'data': zoteroItem.data,
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Render a list of Zotero items
 * @param  {Object[]} zoteroItems - List of Zotero items
 * @return {String}                          - Rendered markup of a list of Zotero items
 */


Renderer.prototype.renderItems = function (zoteroItems) {
  return (0, _items.default)({
    'items': zoteroItems,
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Render a group of Zotero items
 * @param  {Object[]} items 	- List of items for this group
 * @return {String}             - Rendered markup of a group
 */


Renderer.prototype.renderGroup = function (items) {
  return (0, _group.default)({
    'title': (0, _utils.formatCategoryName)(items[_constants.GROUP_TITLE]),
    'items': items,
    'expand': items[_constants.GROUP_EXPANDED_SUMBOL],
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Renders a list of groups of Zotero items
 * @param {Object[]} 	- List of groups to render
 * @return {String} 	- Rendered markup of groups
 */


Renderer.prototype.renderGroups = function (groups) {
  return (0, _groups.default)({
    'groups': groups,
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Render a Group View
 * @param {ZoteroData} 	- List of groups to render
 * @return {String} 	- Rendered markup of a complete group view
 */


Renderer.prototype.renderGroupView = function (data) {
  return (0, _groupView.default)({
    'groups': data,
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Render a Plain View
 * @param  {ZoteroData} zoteroItems - List of Zotero items
 * @return {String} 	- Rendered markup of a complete plain view
 */


Renderer.prototype.renderPlainView = function (data) {
  return (0, _plainView.default)({
    'items': data,
    'renderer': this,
    constants: _constants.default,
    utils: _utils.default
  });
};
/**
 * Render Zotero branding
 * @return {String}
 */


Renderer.prototype.renderBranding = function () {
  if (this.config.showBranding) {
    return (0, _branding.default)({
      constants: _constants.default,
      utils: _utils.default
    });
  } else {
    return '';
  }
};

var _default = Renderer;
exports.default = _default;